"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportWebVitals = exports.initShoppingStore = exports.App = void 0;
const react_1 = __importStar(require("react"));
const app_1 = __importDefault(require("next/app"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const isomorphic_1 = require("@amzn/monera-app-core/lib/isomorphic");
const metrics_1 = require("@amzn/monera-app-core/lib/metrics");
const state_1 = require("@amzn/monera-app-core/lib/state");
const stores_container_1 = require("@amzn/monera-app-core/lib/state/components/stores-container");
const registry_1 = require("@amzn/monera-app-core/lib/state/registry");
const stores_1 = require("@amzn/monera-app-core/lib/state/stores");
const shopping_portal_1 = require("@amzn/monera-app-core/lib/utils/shopping-portal");
const window_1 = require("@amzn/monera-app-core/lib/utils/window");
const aws_rum_provider_1 = __importDefault(require("../components/aws-rum-provider/aws-rum-provider"));
const constants_1 = require("../constants");
const App = (props) => {
    const { Component, pageProps, requestId, statusCode, rumConfig } = props;
    (0, react_1.useEffect)(() => {
        if ((0, window_1.isClientSide)()) {
            monera_app_core_1.csm.emitFunctionalMetric();
            monera_app_core_1.csm.emitPageLoadComplete();
        }
    }, [monera_app_core_1.csm.getScope()]);
    isomorphic_1.LOGGER.info(`Rendering Monera App`);
    if ((0, window_1.isClientSide)() && statusCode) {
        window.moneraStatusCode = statusCode;
    }
    return (react_1.default.createElement(stores_container_1.StoresContainer, { scope: requestId },
        react_1.default.createElement(aws_rum_provider_1.default, Object.assign({}, rumConfig),
            react_1.default.createElement(Component, Object.assign({}, pageProps)))));
};
exports.App = App;
exports.App.getInitialProps = (appContext) => __awaiter(void 0, void 0, void 0, function* () {
    const { req, res } = appContext.ctx;
    const statusCode = res === null || res === void 0 ? void 0 : res.statusCode;
    const requestId = req ? req.id : window.moneraRequestId;
    if ((0, window_1.isServerSide)()) {
        const extendedRequest = req;
        const weblabTreatments = extendedRequest.weblabRequestHeader;
        isomorphic_1.LOGGER.info(`Updating config store`);
        yield registry_1.registry.getStore(stores_1.configStore, requestId).getActions().init({ requestId });
        yield registry_1.registry
            .getStore(stores_1.shoppingPortalStore, requestId)
            .getActions()
            .init(initShoppingStore(extendedRequest.shoppingPortalRequestHeaders));
        yield registry_1.registry.getStore(stores_1.weblabStore, requestId).getActions().init({ weblabTreatments });
    }
    else {
        yield (0, state_1.initClientsideStoreRegistry)(requestId);
    }
    const rumConfig = {
        applicationId: constants_1.RUM_APPLICATION_ID,
        identityPoolId: constants_1.RUM_IDENTITY_POOL_ID,
        guestRoleArn: constants_1.RUM_GUEST_ROLE_ARN
    };
    const appProps = yield app_1.default.getInitialProps(appContext);
    return Object.assign(Object.assign({}, appProps), { requestId, statusCode, rumConfig });
});
function initShoppingStore(spHeaders) {
    const deviceType = (0, shopping_portal_1.getDeviceType)(spHeaders.deviceAttributes, spHeaders.cookie);
    delete spHeaders.cookie;
    delete spHeaders.authToken;
    delete spHeaders.sessionIdAuthToken;
    const state = Object.assign(Object.assign({}, spHeaders), { deviceType });
    isomorphic_1.LOGGER.info('Initializing shopping portal store and filtering un-necessary headers');
    return state;
}
exports.initShoppingStore = initShoppingStore;
function reportWebVitals(metric) {
    const recordTimers = (0, metrics_1.curriedRecordTimers)();
    const emitWebVitals = curriedEmitWebVitals(recordTimers);
    switch (metric.name) {
        case 'FCP':
            emitWebVitals('FirstContentfulPaint', metric.value);
            break;
        case 'TTFB':
            emitWebVitals('TimeToFirstByte', metric.value);
            break;
        case 'LCP':
            emitWebVitals('LargestContentfulPaint', metric.value);
            break;
        case 'FID':
            emitWebVitals('FirstInputDelay', metric.value);
            break;
        case 'CLS':
            emitWebVitals('CumulativeLayoutShift', metric.value);
            break;
        case 'Next.js-hydration':
            emitWebVitals('NextJSHydration', metric.value);
            break;
        default:
            break;
    }
}
exports.reportWebVitals = reportWebVitals;
const curriedEmitWebVitals = (recordTimers) => (metricName, value) => {
    const methodName = 'EmitWebVitals';
    const tenant = window.moneraTenant;
    const timers = [
        {
            name: methodName,
            eventName: 'ALL' + ':Latency:' + metricName,
            value
        }
    ];
    if (tenant) {
        timers.push({ name: methodName, eventName: tenant + ':Latency:' + metricName, value });
    }
    return recordTimers(timers);
};
